import React from 'react'
import * as api from '../../api';
import { toast } from 'react-toastify';
import { Grid,Dimmer, Loader, Button, Input, Modal } from 'semantic-ui-react';
 
class DataMapAccessModal extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            userList: [],
            open: false,
            delBtnOpen: false,
            userId: "",
            loading:false,
        }
    }
    fetchData() {
        api.getMapUserList(this.props.mapSource)
            .then(data => {
                this.setState({ userList: data.data, loading:false });
            }).catch(function (error) {
                // Acquire token interactive failure
                this.setState({ loading:false });
            });

    }
    onNewUserDetails = (event, data) => {
        this.setState({ [data.name]: data.value })
    }

    handleNewUser = (mapsource) => {

      

        if (this.state.userId === '') {
            return
        }
        
      
       // try {
            api.NewDataMapUserDetails(mapsource, this.state.userId)
                .then(verifyRes => {
                  
                    if (verifyRes.status === "Success") {
                        this.setState({
                            open: false,
                            loading: false
                        });
                        this.notify("Successfully saved !");
                    }else
                    {

                     
    
                        this.setState({
                            open: false,
                            loading:false
                        });
                        this.notify(verifyRes.error[0].description,true);
                       
                    }

                })
                .catch((error) => {
                     this.setState({
                        open: false,
                        loading:false
                    });
                  
                    this.notify("Unhandled Error - contact IT Helpdesk",true);
                });
      

        this.setState({
            firstName: '',
            surname: '',
            userId: '',
            roleId: ""
        })
    }

    notify = (message,error = false) => {
        if(error)
        {
            toast.error(message, {
                position: toast.POSITION.TOP_CENTER,
                delay: 2000
            });
        }else
        {
        toast.success(message, {
            position: toast.POSITION.TOP_CENTER,
            delay: 2000
        });
    }
    }

    deleteUserRecord = (email) => {

      
        api.DeleteMapUser(this.props.mapSource, email)
            .then((data) => {
                
                if (data.status === "Success") {
                    this.notifyToDeletedRecord();
                   
                    this.fetchData()
                }
            }).catch((error) => {
                this.setState({
                       
                    loading: false
                });
            })
    }

    notifyToDeletedRecord = () => {
        toast.warning("Successfully deleted !", {
            position: toast.POSITION.TOP_CENTER,
            delay: 500
        });
    }



    render() {
        
      

        return <>
            <Modal size="medium"
                trigger={<Button id='add-user' compact floated='right' size="small" >Edit Access</Button>}
                onOpen={() => { 
                    this.fetchData()
                    this.setState({ open: true, loading: true })}}
                onClose={() => this.setState({ open: false })}
                open={this.state.open}
            >
                <Modal.Header>{this.props.mapSource + " - " + this.props.mapName}</Modal.Header>
                <Modal.Content >
                <Dimmer active={this.state.loading}>
                         <Loader>Checking user access</Loader>
                </Dimmer>
                    <Grid padded stackable columns='equal'>
                        <Grid.Row>
                            
                            <Grid.Column>
                                <p>Please enter an e-mail address below to allow access to data map:</p>
                                <Input icon='at'
                                    fluid
                                    placeholder='e-mail'
                                    name="userId"
                                    onChange={this.onNewUserDetails}

                                />
                            </Grid.Column>
                        </Grid.Row>


                        <Grid.Row>
                        <table className="ui celled table">
                            <thead>
                                <tr><th>UserName</th>
                                <th>Action</th>
                                </tr></thead>
                            <tbody>
                        {this.state.userList.map(title =>

                        {
                            return (
                               
                        <tr  key={title.id}>
                            <td data-label="UserName">{title.username}</td>
                        <td data-label="Action">                    
                        
                        <Button size='small' content="Delete"
                            
                            onClick={() => 
                                {
                                    this.setState({
                       
                                        loading: true
                                    });
                                    this.deleteUserRecord(title.username)
                                }}
                            negative
                        />
                    
                    
                    
                    </td>
                        </tr>
                            )
                        }          
                        )}
                         </tbody>
                        </table>
                            <Grid.Column></Grid.Column>
                            <Grid.Column></Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        basic color='red'
                        compact
                        onClick={() => this.setState({ open: false })}
                    >Cancel</Button>
                    <Button
                        compact
                        id='confirm-user'
                        onClick={() => this.handleNewUser(this.props.mapSource)}
                    >Add User</Button>
                </Modal.Actions>
            </Modal>
        </>
    }
}
export default DataMapAccessModal;